import {fcFormConfig} from '@/views/TextCreateV2/create/config/fcFormConfig';
import {feedFormConfig} from '@/views/TextCreateV2/create/config/feedFormConfig';
import {scriptFormConfig} from '@/views/TextCreateV2/create/config/scriptFormConfig';
import {shortplayFormConfig} from '@/views/TextCreateV2/create/config/shortplayFormConfig';
import {pageConfig} from '@/views/TextCreateV2/create/config';
import {templateTextFormConfig} from '@/views/V2/image/template/utils/templateTextFormConfig.js';
const configMap = {
    feed: feedFormConfig,
    fc: fcFormConfig,
    script: scriptFormConfig,
    shortplay: shortplayFormConfig,
    templateText: templateTextFormConfig
};
export default {
    namespaced: true,
    state: {
        source: 'feed',
        loadingData: {} // loading时生成区域需要展示的数据
    },
    mutations: {
        SET_SOURCE: (state, val) => {
            state.source = val;
        },
        SET_LOADING_DATA: (state, val) => {
            const generateType = pageConfig[state.source].type;
            state.loadingData[generateType] = val;
        }
    },
    getters: {
        formConfig: state => {
            return configMap[state.source];
        },
        generateType: state => {
            return pageConfig[state.source].type;
        }
    }
};